<!--
  This HTML code represents the user action component of the base header.
-->

<div class="flex items-center gap-1">
  <app-timezone-indicator class="flex items-center"></app-timezone-indicator>
  <app-language-switch class="flex items-center"></app-language-switch>
  <app-theme-switch class="flex items-center"></app-theme-switch>
  <app-user-info class="flex items-center"></app-user-info>
</div>
